import angular from 'angular';

export class NsjAccordionDisableToggleDirective implements ng.IDirective {
    static restrict = 'A';

    static Factory() {
        return () => new NsjAccordionDisableToggleDirective();
    }

    link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
        const hostElement = element[0] as HTMLElement;
        let disabled = false;

        const clickCaptureHandler = (event: Event) => {
            if (!disabled) {
                return;
            }

            const target = event.target as HTMLElement | null;
            const clickedInsideActions = target ? !!target.closest('.pull-right') : false;
            const clickedHeader = target ? !!target.closest('.card-header') : false;

            if (!clickedHeader || clickedInsideActions) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
        };

        hostElement.addEventListener('click', clickCaptureHandler, true);

        scope.$watch(
            () => scope.$eval(attrs['nsjAccordionDisableToggle']),
            (value: any) => {
                disabled = !!value;
            }
        );

        scope.$on('$destroy', () => {
            hostElement.removeEventListener('click', clickCaptureHandler, true);
        });
    }
}

export const NsjAccordionDisableToggleModule = angular.module('NsjAccordionDisableToggleModule', [])
    .directive('nsjAccordionDisableToggle', NsjAccordionDisableToggleDirective.Factory())
    .name;
